import { Component } from "react";
import { instanceOf, string, shape } from "prop-types";
import styled from "styled-components/macro";
import { rem } from "polished";

import { validationPatterns } from "../../../helpers";

class Text extends Component {
  constructor(props) {
    super(props);

    this.setPattern = this.setPattern.bind(this);

    this.state = { pattern: this.props.pattern };
  }

  setPattern() {
    const { id, pattern, type } = this.props;

    if (!pattern) {
      if (
        !!validationPatterns[type] &&
        validationPatterns[type] !== this.state.pattern
      ) {
        this.setState({ pattern: validationPatterns[type] });
      } else if (id === "customPrice" || id === "loanAmount") {
        this.setState({ pattern: validationPatterns.dollar });
      } else if (id === "zip") {
        this.setState({ pattern: validationPatterns.zip });
      }
    }
  }

  componentDidMount() {
    this.setPattern();
  }

  render() {
    const { inputRef, size, type, ...rest } = this.props;
    const { pattern } = this.state;

    return (
      <Input
        {...rest}
        pattern={pattern}
        ref={inputRef}
        size={size}
        type={type}
      />
    );
  }
}

Text.propTypes = {
  id: string,
  inputRef: shape({
    current: instanceOf(Element),
  }),
  size: string,
  type: string,
};

Text.defaultProps = {
  type: "text",
};

export const Input = styled.input`
  background-clip: padding-box;
  background-color: ${({ readOnly, theme }) =>
    readOnly ? theme.text.backgroundColorReadOnly : theme.text.backgroundColor};
  border: ${rem("1px")} solid
    ${({ readOnly, theme }) =>
      readOnly ? theme.text.borderColorReadOnly : theme.text.borderColor};
  border-radius: ${rem("5px")};
  color: ${({ theme }) => theme.input.color};
  display: block;
  font-size: ${({ size, theme }) => {
    switch (size) {
      case "small":
        return rem("16px");
      default:
        return theme.input.fontSize;
    }
  }};
  height: ${rem("45px")};
  max-width: 100%;
  padding: ${({ theme }) => theme.input.paddingY} ${rem("14px")};
  width: 100%;

  &:focus {
    outline: ${rem("1px")} dotted;
    outline-offset: ${rem("2px")};
  }

  .has-error & {
    border-color: ${({ theme }) => theme.error.color};
  }
`;

export default Text;
